import { z } from 'zod';

import { ContractError } from '../../api';

const overrideEffectSchema = z.enum(['grant', 'revoke']);

const mePlantSchema = z.object({
  deltas: z.record(overrideEffectSchema),
  licensedModules: z.array(z.string()),
  exceptions: z.array(z.string()),
});

export const mePayloadSchema = z.object({
  roleKey: z.string().nullable(),
  adminGrant: z.string().nullable(),
  adminKeys: z.array(z.string()),
  adminGrantClusterId: z.string().nullable(),
  isStaff: z.boolean(),
  permissionsVersion: z.number(),
  landing: z.string().nullable(),
  baseKeys: z.array(z.string()),
  plantIds: z.array(z.string()),
  plants: z.record(mePlantSchema),
  empty: z.boolean().optional(),
  note: z.string().optional(),
});

export type MePayload = z.infer<typeof mePayloadSchema>;

export class AccessContractError extends ContractError {
  constructor(message: string, issues: unknown) {
    super(message, issues);
    this.name = 'AccessContractError';
  }
}

export const parseMe = (raw: unknown): MePayload => {
  const result = mePayloadSchema.safeParse(raw);
  if (!result.success) throw new AccessContractError('Invalid /v2/permissions/me payload', result.error.issues);
  return result.data;
};

const siteAccessEntrySchema = z.object({
  plantId: z.string(),
  canView: z.boolean(),
  canEditNotifications: z.boolean(),
  canEditPlant: z.boolean(),
  canManagePeople: z.boolean(),
});

const siteAccessPayloadSchema = z.object({ plants: z.array(siteAccessEntrySchema) });

export type SiteAccessPayload = z.infer<typeof siteAccessPayloadSchema>;

export const parseSiteAccess = (raw: unknown): SiteAccessPayload => {
  const result = siteAccessPayloadSchema.safeParse(raw);
  if (!result.success) throw new AccessContractError('Invalid /v2/permissions/site-access payload', result.error.issues);
  return result.data;
};
